import { NAVIGATE, DISMISS_SIDENAV_ANNOUNCEMENT } from '../../../ActionsConst';

export const navigateTo = (url) => ({
  type: NAVIGATE,
  url,
});

export const dismissSideNavAnnouncement = () => {
  localStorage.setItem('userDismissedSideNavAnnouncement', 'true');

  return {
    type: DISMISS_SIDENAV_ANNOUNCEMENT,
  };
};
